// TikTok events tracking via DOM event delegation.
// Plus robuste que les onClick React: utilise la phase capture pour firer
// AVANT la navigation (ex: liens tel:, mailto:, wa.me qui ouvrent immediatement).
// Devise des events: XOF (Franc CFA).

const track = (event, params) => {
  if (typeof window === "undefined") return;
  const ttq = window.ttq;
  if (!ttq || typeof ttq.track !== "function") return;
  try {
    ttq.track(event, params);
    // Log visible dans la console navigateur pour debug rapide
    // (en plus de ttq.debug(true) qui log par TikTok lui-meme)
    // eslint-disable-next-line no-console
    console.log("[TikTok][track]", event, params);
  } catch (e) {
    // swallow: tracking never breaks the UI
  }
};

const hasText = (el, regex) => {
  if (!el) return false;
  const txt = (el.textContent || "").trim();
  return regex.test(txt);
};

const onClick = (e) => {
  const target = e.target;
  if (!target || typeof target.closest !== "function") return;

  // 7. Réservez en VEFA -> CompleteRegistration + Lead
  //    (a tester EN PREMIER car le bouton contient parfois d'autres enfants)
  const vefaBtn = target.closest("button, a");
  if (vefaBtn && hasText(vefaBtn, /r[ée]servez\s+en\s+vefa/i)) {
    track("CompleteRegistration", {
      content_id: "vefa_registration",
      content_name: "Réservation VEFA",
      value: 50000,
      currency: "XOF",
    });
    track("Lead", {
      content_name: "Lead VEFA premium",
      value: 50000,
      currency: "XOF",
    });
    return;
  }

  // 5. Download - Catalogue PDF (bouton avec texte "catalogue" OU lien .pdf)
  const pdfLink = target.closest('a[href$=".pdf"], a[href*=".pdf?"]');
  const catalogueBtn = (() => {
    const b = target.closest("button, a");
    return b && hasText(b, /catalogue/i) ? b : null;
  })();
  if (pdfLink || catalogueBtn) {
    track("Download", {
      content_id: "catalogue_pdf",
      content_name: "Catalogue PDF",
      value: 10000,
      currency: "XOF",
    });
    return;
  }

  // 3. WhatsApp (CRITIQUE) - AVANT les selecteurs tel:/mailto: qui matcheraient pas
  const waLink = target.closest('a[href*="wa.me"], a[href*="whatsapp"]');
  if (waLink) {
    track("Contact", {
      content_id: "whatsapp_click",
      content_name: "Clic WhatsApp",
      value: 8000,
      currency: "XOF",
    });
    return;
  }

  // 1. Téléphone
  const telLink = target.closest('a[href^="tel:"]');
  if (telLink) {
    track("Contact", {
      content_id: "phone_click",
      content_name: "Clic téléphone",
      value: 5000,
      currency: "XOF",
    });
    return;
  }

  // 2. Email
  const emailLink = target.closest('a[href^="mailto:"]');
  if (emailLink) {
    track("Contact", {
      content_id: "email_click",
      content_name: "Clic email",
      value: 3000,
      currency: "XOF",
    });
    return;
  }

  // 6. ViewContent - carte d'appartement (via data-apartment-type)
  const aptCard = target.closest("[data-apartment-type]");
  if (aptCard) {
    const type = (aptCard.getAttribute("data-apartment-type") || "").trim();
    if (type) {
      track("ViewContent", {
        content_id: "apt_" + type.toLowerCase().replace(/\s+/g, "_"),
        content_name: "Appartement " + type,
        content_type: "real_estate_unit",
        currency: "XOF",
      });
    }
    return;
  }
};

const onSubmit = (e) => {
  const form = e.target;
  if (!form || form.tagName !== "FORM") return;
  // 4. SubmitForm + Lead
  track("SubmitForm", {
    content_id: "contact_form",
    value: 15000,
    currency: "XOF",
  });
  track("Lead", {
    content_name: "Lead RYAD",
    value: 15000,
    currency: "XOF",
  });
};

let __initialized = false;

export function initTikTokEvents() {
  if (typeof document === "undefined" || __initialized) return;
  __initialized = true;
  // Phase capture = true pour firer avant la navigation/link-follow
  document.addEventListener("click", onClick, true);
  document.addEventListener("submit", onSubmit, true);
  // eslint-disable-next-line no-console
  console.log("[TikTok] Event delegation listeners attached");
}
